import io from "socket.io-client";
import messagingSocket from "./messaging.socket";
import { AIGC_EXTERNAL_API_ENDPOINT } from "config/env";

// const apiEndPoint = "https://gpt-api-stg.sernsoft.com"; //
const apiEndPoint = AIGC_EXTERNAL_API_ENDPOINT;
const apiEndPointStg = "http://192.168.0.39:8005";
// apiEndPointStg: "http://localhost:8005",
const recaptchaSiteKey = "6LcozuoiAAAAABrUE0LuigvLn5bw6cRLOWaIzNp7";

const host = apiEndPoint;
// apiEndPointStg;

var socketConnector;

const apis = {
  socketConnector: socketConnector,
  initSocket: (apiURL) => {
    const socket = io(apiEndPoint);
    // const socket = io(apiURL ? apiURL : host);
    socket.compress(true);
    socketConnector = socket;
    console.log("Socket Init Success");
    // Init modules
    messagingSocket.initModule(socketConnector);
    return socket;
  },
  connectionStatus: (cb) => {
    socketConnector.on("connect", () => {
      cb({
        connected: true,
      });
    });
    socketConnector.on("disconnect", () => {
      cb({
        connected: false,
      });
    });
  },
};

export default apis;
